module.exports = __webpack_public_path__ + "static/team_training_icon-a9633cacf7a19448fa2a0caa1080cd7f.png";